import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, Checkbox, Popover, } from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import * as Suggestion from '@services/suggestion/suggestion.action';
import LocationIcon from '@material-ui/icons/PlaceRounded';
import TimeIcon from '@material-ui/icons/ScheduleRounded';
import SendIcon from '@material-ui/icons/Send';
import { EditEventStyle } from './EditEvent.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import VVTimePicker from '@components/common/timepicker/VVTimePicker';
import VVDatePicker from '@components/common/timepicker/VVDatePicker';
import { ICreateSuggestion } from '@app-types/websocket/suggestion.types';
import { addQuickSleep, hasChildAtTime } from '../editPane/editActions/QuickChange/QuickChangeCalc';
import { generateSuggestions } from '@helpers/calendar/suggestionCalculator';
import { addDays } from '@helpers/DateHelper';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import { ISchedule } from '@app-types/websocket/schedule.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  start:Date;
  end:Date;
  startLoc:string;
  endLoc:string;
  startAtSchool:boolean;
  endAtSchool:boolean;

  
  
  editAnchorEl:HTMLDivElement|null;
  edit:"STARTTIME"|"STARTDATE"|"ENDTIME"|"ENDDATE"|null;
}

interface IProps extends WithStyles<typeof EditEventStyle> {
  userId:number,
  initialDay: Date;
  parent:number,
  scheduleId:number;
  schedules:ISchedule[];
  family:IFamilyMember[];
  close:() => void;
  createSuggestion: (data: ICreateSuggestion) => void;
}

class AddScheduleSleep extends React.Component<IProps, IState> {

  private startDateRef:React.RefObject<HTMLDivElement> = React.createRef();
  private startTimeRef:React.RefObject<HTMLDivElement> = React.createRef();
  private startLocRef:React.RefObject<HTMLInputElement> = React.createRef();
  private endDateRef:React.RefObject<HTMLDivElement> = React.createRef();
  private endTimeRef:React.RefObject<HTMLDivElement> = React.createRef();
  private endLocRef:React.RefObject<HTMLInputElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    const start = new Date(props.initialDay);
    start.setHours(12,0,0,0);

    const end = addDays(start,1);

    this.state = {
      start,
      end,
      startLoc:"",
      endLoc:"",
      startAtSchool:true,
      endAtSchool:true,
      editAnchorEl:null,
      edit:null,
    };

  }

  public render() {
    const {classes, family, userId, schedules, scheduleId,parent} = this.props;
    const {start,end,startLoc,endLoc,startAtSchool,endAtSchool} = this.state;
    const handoverDates = this.getHandoverDates();
    const validToSave = this.validToSave();
    const schedule = schedules.find((s) => s.id === scheduleId);

    const kids:number[] = schedule?schedule.data.children:[];
    const school = schedule?schedule.school:undefined;
    const schoolAge = schoolAgeFromFamily(family);
    const startSchoolLabel = tn.lang.calResponsibilityFromSchool(school, schoolAge);
    const endSchoolLabel = tn.lang.calResponsibilityUntilSchool(school, schoolAge);

    const startMorningTime:Date = new Date(start);
    startMorningTime.setMinutes(1);
    startMorningTime.setHours(0);
    const endNightTime:Date = new Date(end);
    endNightTime.setHours(23);
    endNightTime.setMinutes(59);

    const hasChildAlreadyAtStart = hasChildAtTime(parent,schedule,startMorningTime.getTime(),"START");
    const hasChildAlreadyAtEnd = hasChildAtTime(parent,schedule,endNightTime.getTime(),"END");

    return (
    <div  className={classes.scrollView} >
      <div className={classes.pane}>

      <div className={classes.section} style={{borderBottom: '1px solid #888'}}>
          <div style={{flexDirection: 'column', display:'flex', alignItems: 'center'}}>
            <span style={{fontSize: '20px', padding: '6px', fontWeight: 600}}>{tn.lang.calTakesOver(tn.familyMemberName(parent,family))} </span>
            <span>{tn.lang.calTakesOverFor(tn.familyMemberNames(kids,family))}</span>
          </div>
        </div>

        <div className={classes.section} >
          <div className={classes.row}>
            <div className={classes.leftColumn} ><TimeIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} >
            <div className={classes.fullwidth} >{tn.lang.eventStart}</div>
            <div style={{display: 'flex', width: '233px'}}>
              <div className={classes.greyInput + " " +classes.date} ref={this.startDateRef}
                onClick={() => this.setState({edit:"STARTDATE", editAnchorEl:this.startDateRef.current})}>
                {tn.formatDateDayMonthYear(start)}
              </div>
              <div className={classes.greyInput + " " +classes.time} ref={this.startTimeRef} 
                style={hasChildAlreadyAtStart!==null?{display:'none'}:(startAtSchool?{maxWidth: 0,minWidth: 0,padding: 0,margin: 0}:{})}
                onClick={() => this.setState({edit:"STARTTIME", editAnchorEl:this.startTimeRef.current})}>
                <span>{tn.formatTime(handoverDates.start)}</span>
              </div>
            </div>
            </div>
          </div>

          <div className={classes.row} style={{maxHeight:'unset', display:(hasChildAlreadyAtStart!==null?'flex':'none'), fontStyle: 'italic'}}>
            {tn.lang.calContinueStart(tn.familyMemberName(parent,family),
              hasChildAlreadyAtStart?tn.formatDateDayMonthYear(new Date(hasChildAlreadyAtStart)):tn.lang.unknown)}
          </div>

          <div className={classes.row} style={{maxHeight:'unset', display:(hasChildAlreadyAtStart!==null?'none':'flex')}}>
            <div className={classes.leftColumn} >
              <LocationIcon className={classes.greyIcon}/>
            </div>
            <div className={classes.fullwidth} />
            <div className={classes.rightColumn} style={{flexDirection: 'column', minWidth:'234px'}}>
              <div style={{flexDirection:'column', transition: '0.3s', display:'flex', overflow: 'hidden', maxHeight: (startAtSchool?'0px':'48px')}}>
                <input
                  ref={this.startLocRef}
                  id="event-location"
                  type="text"
                  value={startAtSchool?startSchoolLabel:startLoc}
                  spellCheck={true}
                  maxLength={25}
                  onChange={(e) => {this.setState({startLoc:e.target.value})}}
                  className={classes.greyInput + " " +classes.fullwidthInput}
                  placeholder={tn.lang.handoverLocationLabel}/>

                <div className={classes.error} style={(startLoc.length === 0 && !this.state.startLoc)?{maxHeight:'16px'}:{}}>
                  {tn.lang.calPlaceMissing}
                </div>
              </div>

              <div onClick={() => this.setState({startAtSchool:!startAtSchool})} 
                style={{display:'flex', alignItems: 'center'}}>
                <Checkbox
                  edge="start"
                  checked={this.state.startAtSchool}
                  tabIndex={-1}
                  readOnly={true}
                  disableRipple={true}
                  style={{marginLeft: '-10px'}}
                />
                <span>
                  {startSchoolLabel}
                </span>
              </div>
            </div>
          </div>

        </div>


        <div className={classes.section} >
          <div className={classes.row}>
            <div className={classes.leftColumn} ><TimeIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} >
            <div className={classes.fullwidth} >{tn.lang.eventEnd}</div>
            <div style={{display: 'flex', width: '233px'}}>
              <div className={classes.greyInput + " " +classes.date} ref={this.endDateRef}
                onClick={() => this.setState({edit:"ENDDATE", editAnchorEl:this.endDateRef.current})}>
                {tn.formatDateDayMonthYear(end)}
              </div>
              <div className={classes.greyInput + " " +classes.time} ref={this.endTimeRef}
                style={hasChildAlreadyAtEnd!==null?{display:'none'}:(endAtSchool?{maxWidth: 0,minWidth: 0,padding: 0,margin: 0}:{})}
                onClick={() => this.setState({edit:"ENDTIME", editAnchorEl:this.endTimeRef.current})}>
                <span>{tn.formatTime(handoverDates.end)}</span>
              </div>
            </div>
            </div>
          </div>

          <div className={classes.row} style={{maxHeight:'unset', display:(hasChildAlreadyAtEnd!==null?'flex':'none'), fontStyle: 'italic'}}>
          {tn.lang.calContinueEnd(tn.familyMemberName(parent,family),
              hasChildAlreadyAtEnd?tn.formatDateDayMonthYear(new Date(hasChildAlreadyAtEnd)):tn.lang.unknown)}
          </div>

          <div className={classes.row} style={{maxHeight:'unset', display:(hasChildAlreadyAtEnd!==null?'none':'flex')}}>
            <div className={classes.leftColumn} >
              <LocationIcon className={classes.greyIcon}/>
            </div>
            <div className={classes.fullwidth} />
            <div className={classes.rightColumn} style={{flexDirection: 'column', minWidth:'234px'}}>
              <div style={{ flexDirection:'column', transition: '0.3s', overflow: 'hidden', maxHeight: (endAtSchool?'0px':'48px'), display:'flex'}} >
                <input
                  ref={this.endLocRef}
                  id="event-location"
                  type="text"
                  value={endAtSchool?endSchoolLabel:endLoc}
                  spellCheck={true}
                  maxLength={25}
                  onChange={(e) => {this.setState({endLoc:e.target.value})}}
                  className={classes.greyInput + " " +classes.fullwidthInput}
                  placeholder={tn.lang.handoverLocationLabel}/>

                <div className={classes.error} style={(endLoc.length === 0 && !this.state.endLoc)?{maxHeight:'16px'}:{}}>
                  {tn.lang.calPlaceMissing}
                </div>
              </div>

              <div onClick={() => this.setState({endAtSchool:!endAtSchool})} 
                style={{display:'flex', alignItems: 'center'}}>
                <Checkbox
                  edge="start"
                  checked={this.state.endAtSchool}
                  tabIndex={-1}
                  readOnly={true}
                  disableRipple={true}
                  style={{marginLeft: '-10px'}}
                />
                <span>
                  {endSchoolLabel}
                </span>
              </div>
            </div>
          </div>

          {!validToSave && (
            <div className={classes.error} role="alert" style={{maxHeight:'none', fontSize:'12px', lineHeight:'16px'}}>
              {tn.lang.calEndMustBeAfterStart}
            </div>
          )}
        </div>
        <div style={{width:'100%', height:'50px'}}/>
      </div>
      <div className={classes.actions} >
        <Button variant="outlined"  classes={{outlined:classes.buttonOutlinedLarge}} onClick={() => this.props.close()}>
          {tn.lang.cancel}
        </Button>
        <Button variant="contained"  onClick={() => this.save()} disabled={!validToSave} color="primary"
          classes={{contained:classes.buttonContainedLarge}} endIcon={<SendIcon  style={{fontSize: '20px', margin: '-2px 0px'}}/>}>
          {tn.lang.suggestCange}
        </Button>
      </div>
      <Popover 
        anchorEl={this.state.editAnchorEl}
        onClose={() => this.setState({edit:null})}
        open={(this.state.edit === "STARTTIME" || this.state.edit === "ENDTIME")}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <VVTimePicker 
          fullDayOption={false} 
          open={(this.state.edit === "STARTTIME" || this.state.edit === "ENDTIME")}
          hour={(this.state.edit === "STARTTIME")?this.state.start.getHours():this.state.end.getHours()}
          minute={(this.state.edit === "STARTTIME")?this.state.start.getMinutes():this.state.end.getMinutes()}
          setHour={(hour:number) => {if (this.state.edit === "STARTTIME")
            {const newTime = new Date(this.state.start); newTime.setHours(hour); this.setState({start:newTime})}
            else {
              const newTime = new Date(this.state.end); newTime.setHours(hour); this.setState({end:newTime})
            }}}
          setMinute={(min:number) => {if (this.state.edit === "STARTTIME")
            {const newTime = new Date(this.state.start); newTime.setMinutes(min); this.setState({start:newTime})}
            else {
              const newTime = new Date(this.state.end); newTime.setMinutes(min); this.setState({end:newTime})
            }}}
        />
      </Popover>
      <Popover 
        anchorEl={this.state.editAnchorEl}
        onClose={() => this.setState({edit:null})}
        open={(this.state.edit === "ENDDATE" || this.state.edit === "STARTDATE")}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <VVDatePicker 
          open={(this.state.edit === "ENDDATE" || this.state.edit === "STARTDATE")}
          date={(this.state.edit === "STARTDATE")?this.state.start:this.state.end}
          setDate={(date:Date) => {
            
            if (this.state.edit === "STARTDATE") {
              const newTime = new Date(date); 
              newTime.setMinutes(this.state.start.getMinutes()); 
              newTime.setHours(this.state.start.getHours()); 
              this.setState({start:newTime});
            } else {
              const newTime = new Date(date); 
              newTime.setMinutes(this.state.end.getMinutes()); 
              newTime.setHours(this.state.end.getHours()); 
              this.setState({end:newTime});
            }}}
        />
      </Popover>
    </div>);
  }

  private getHandoverDates():{start:Date; end:Date} {
    const start = new Date(this.state.start);
    const end = new Date(this.state.end);
    if (this.state.startAtSchool) {
      start.setHours(12,0,0,0);
    }
    if (this.state.endAtSchool) {
      end.setHours(12,0,0,0);
    }
    return {start,end};
  }

  private validToSave():boolean {
    const {start,end} = this.getHandoverDates();
    return start.getTime() < end.getTime();
  }

  private save():void {
    if (!this.validToSave()) {
      return;
    }
    const schedule = this.props.schedules.find((s) => s.id === this.props.scheduleId);
    if (schedule) {

      const {start,end} = this.getHandoverDates();
    
      const startMorningTime:Date = new Date(start);
      startMorningTime.setMinutes(1);
      startMorningTime.setHours(0);
      const endNightTime:Date = new Date(end);
      endNightTime.setHours(23);
      endNightTime.setMinutes(59);

      const hasChildAlreadyAtStart = hasChildAtTime(this.props.parent,schedule,startMorningTime.getTime(),"START");
      const hasChildAlreadyAtEnd = hasChildAtTime(this.props.parent,schedule,endNightTime.getTime(),"END");

      if (hasChildAlreadyAtStart !== null) {
        start.setMinutes(1);
        start.setHours(0);
      }

      if (hasChildAlreadyAtEnd !== null) {
        end.setMinutes(59);
        end.setHours(23);
      }


      const newSchedule = addQuickSleep(schedule, start.getTime(), end.getTime(), this.state.startAtSchool, this.state.endAtSchool, 
        this.state.startLoc, this.state.endLoc, this.props.parent);
      const suggestion:ICreateSuggestion = generateSuggestions(schedule, newSchedule);
      if (suggestion.changes.length > 0) {
        suggestion.track = true;
        this.props.createSuggestion(suggestion);
      }
      // console.log("RESULT: "+JSON.stringify(suggestion));
      this.props.close();   
    }
  }

}


function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  const schedules:ISchedule[] =  state.schedule.schedules?state.schedule.schedules:[];

  return {
    userId,
    family:state.family.family,
    schedules,
  };
}

const mapDispatchToProps = {
  createSuggestion: Suggestion.createSuggestion,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EditEventStyle)(AddScheduleSleep));



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/AddScheduleSleep.tsx